import { createContext } from "react";

/**
 * Runtime chrome control for pages inside `ModulePageLayout`. Lets a page hide
 * the breadcrumb bar dynamically (e.g. the calendar's Fit mode reclaims that
 * strip for the grid). Static hiding stays on the route's `noBreadcrumb`.
 *
 * WHY THIS IS ITS OWN FILE (2026-07-27)
 * -------------------------------------
 * `ModulePageLayout.tsx` provides this context, and the `calendars` module is
 * its only consumer. But `ModulePageLayout.tsx` is NOT a file Module Sync can
 * carry to a tenant: five tenant repos (annadurham, block_52_biz_dev_fe,
 * bloomingbrilliant-frontend, paradiselakescarecenter_fe, surgready_2026) pass
 * a single `layoutOptions={…}` prop from their own `App.tsx`, while this repo's
 * copy takes the same options as individual props. Carrying this repo's copy
 * would make every one of those tenants' `App.tsx` fail type-check — and
 * `App.tsx` is on the sync's `TENANT_OWNED_APP_FILES` denylist, so the sync
 * could never repair what it broke. `ModulePageLayout` is tenant app-shell
 * chrome, like the Navbar and Footer it wraps.
 *
 * The context itself has none of that baggage: no props, no branding, no
 * dependencies beyond React. Split out here it is a leaf a module can import
 * and DECLARE in its `### Shared files` manifest, and because the file is new
 * everywhere the carry is always an `added`, never an overwrite.
 *
 * `ModulePageLayout.tsx` re-exports it, so `import { LayoutChromeContext } from
 * "./ModulePageLayout"` keeps working for anything already doing that.
 *
 * TENANT NOTE: a tenant's own `ModulePageLayout.tsx` still declares its own
 * copy of this context, so until that copy is re-pointed at this file the
 * calendar's Fit mode simply leaves the breadcrumb visible there. That is a
 * cosmetic no-op, not a broken build — which is the whole point of the split.
 */
export const LayoutChromeContext = createContext<{
  setBreadcrumbHidden: (hidden: boolean) => void;
}>({ setBreadcrumbHidden: () => {} });
